import { Controller, useFormContext } from "react-hook-form";
import { ThemeVariablesContainer } from "../../ThemeVariablesContainer";
import { VisualEmailTiptapEditor } from "./VisualEmailTiptapEditor";

export interface FormTipTapEditorProps {
  name: string;
  placeholder?: string;
}

export const FormTipTapEditor = ({
  name,
  placeholder = "Enter text...",
}: FormTipTapEditorProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur } }) => (
        <ThemeVariablesContainer>
          <VisualEmailTiptapEditor
            value={value as string | undefined}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            shouldShowMenuBar
          />
        </ThemeVariablesContainer>
      )}
    />
  );
};
